export default __webpack_public_path__ + "static/media/Clínica-Viamao.bfcb85b6.png";